// extracted by mini-css-extract-plugin
export default {"tagline":"Faq_tagline__7HyWl"};